import React from 'react'
import styled from 'styled-components'
import imagePath from '../../../assets/image/check/ic-unchecked.png'

const ChkBox = ({ className, id, value, checked, onChange }) => {
  return (
    <ChkWrap className={className}>
      <input
        type="checkbox"
        className="ir"
        id={id}
        value={value}
        checked={checked}
        onChange={onChange}
      />
      <label htmlFor={id}></label>
    </ChkWrap>
  )
}

export default ChkBox

const ChkWrap = styled.div`
  input[type='checkbox'] + label {
    width: 24px;
    height: 24px;
    cursor: pointer;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    background-image: url(${require('../../../assets/image/check/ic-unchecked.png')});
  }

  input[type='checkbox']:checked + label {
    background-image: url(${require('../../../assets/image/check/ic-checked.png')});
  }
`
